import { Component, Prop, Vue } from 'vue-property-decorator';
import store from "Store/index"
import { OrderingListUserPermissionViewModel } from 'Api/CoreApi';
import BaseComponent from 'Components/Base/ABaseComponent';
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';
import { mixins } from 'vue-class-component';

@Component({
})
export default class OrderinglistConditionLimitPermissionComponent extends mixins(BaseComponent,OrderingListUserMixin){
    
    
    @Prop()
    public limitByPermissionCanViewOrderHistoric: boolean;
    
    
    private selectedListId: string;
    
    
    
    async created(){
        this.setLoading();
        //only validate by employee for now
        if(this.isEmployee) { 
            await store.dispatch.orderingList.loadOrderingLists(false);
            
            const user = store.state.auth.user;
            this.selectedListId = user?.extraInfo?.SelectedListId;
        }
        this.setLoaded();
        
    }
    
    
    get isRestricted(){
        if(!this.isEmployee) return false;
        
        const selectedList = store.getters.orderingList.orderingLists.find(x => x.id == this.selectedListId);
        
        
        if(selectedList){
            
            if(selectedList.permissions.canViewOrderHistoric && this.limitByPermissionCanViewOrderHistoric){
                return false;
            }
        }
        
        return true;
    }
}

Vue.component('orderinglist-conditional-limit-permission', OrderinglistConditionLimitPermissionComponent);